import { commonComponents as cc } from "@/components/common";
import { ui } from "@patient-watch/ui";
import { cn } from "@/lib/utils";

import { CatchBoundary } from "@tanstack/react-router";
import { icons } from "@patient-watch/icons";

interface Props {
    title?: React.ReactNode;
    children: React.ReactNode;
    lock?: boolean;
    editChildren?: React.ReactNode;
    headerAction?: React.ReactNode;
    className?: string;
    show?: boolean;
    contentClassName?: string;
}
const Group = ({ title, children, lock, className, show, editChildren, headerAction, contentClassName }: Props) => {
    return (
        <section className={cn("mb-4", lock && "cursor-not-allowed", show === false && "hidden", className)}>
            <CatchBoundary getResetKey={() => "reset-group"} errorComponent={GroupFallack}>
                <ui.Card className={cn(lock && "pointer-events-none ")}>
                    {!!title && (
                        <ui.CardHeader className="flex flex-row justify-between items-center gap-3 pb-0 w-full">
                            {title && <ui.CardTitle className="text-xl">{title}</ui.CardTitle>}
                            {lock && <icons.Padlock className="mt-2 mr-1" />}
                            {!lock && headerAction}
                            {!lock && !headerAction && editChildren && <cc.EditButton>{editChildren}</cc.EditButton>}
                        </ui.CardHeader>
                    )}

                    <ui.CardContent className={cn("py-2", lock && "opacity-50", contentClassName)}>
                        {children}
                    </ui.CardContent>
                </ui.Card>
            </CatchBoundary>
        </section>
    );
};

export default Group;

const GroupFallack = () => {
    return (
        <ui.Card>
            <ui.CardHeader>
                <ui.CardTitle>Error in Group</ui.CardTitle>
            </ui.CardHeader>
            <ui.CardContent>
                <ui.Skeleton />
                <ui.Skeleton className="w-1/2" />
            </ui.CardContent>
        </ui.Card>
    );
};
